import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getLoadCasesForActiveComponentDesign = createSelector(
  getActiveComponentDesign,
  (state: RootState) => state.loadSets,
  (activeComponentDesign, loadSets) => {
    if (!activeComponentDesign || !activeComponentDesign.loadSetGuid) return [];
    const loadSet = loadSets[activeComponentDesign.loadSetGuid];
    return loadSet && loadSet.loadCases ? loadSet.loadCases : [];
  },
);

export const getAllLoadsForActiveComponentDesign = createSelector(getLoadCasesForActiveComponentDesign, (loadCases) =>
  loadCases.flatMap(({ loads }) => loads),
);
